import React from "react";
import { Card, Icon, Image, Label } from "semantic-ui-react";
import ButtonBarcodeTube from "features/FolderManager/components/Tubes/ButtonBarcodeTube";
import SecondaryRedButton from "components/Buttons/SecondaryRedButton";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr"; // the locale you want
registerLocale("fr", fr);

const styles = {
	content: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
		cursor: "pointer",
		position: "relative",
	},
};

const regexForTube = (tube) => {
	if (tube.regex) {
		return new RegExp(tube.regex);
	}
	if (tube.sil_code.includes("NPAG")) return new RegExp("^([0-9]{8}|[a-zA-Z][0-9]-[0-9]{2})$");
	return new RegExp(process.env.REACT_APP_BARCODE_REGEX.concat("$"));
};

const TubeDepositCard = ({ tube, openBarcode, disabled, isSelected = false, submitBarCode, cancelSelect, selectTube, setTubeNotPresent }) => {
	return (
		<Card
			style={{
				marginRight: 5,
				marginLeft: 5,
				marginBottom: 10,
				width: "unset",
				backgroundColor: isSelected ? "#f2711c36" : "white",
				maxWidth: "200px",
			}}
			color={isSelected ? "yellow" : "black"}
		>
			<Card.Content
				style={styles.content}
				onClick={(e) => {
					if (e !== undefined) e.preventDefault();
					//openTubeDetails(tube);
				}}
			>
				<Image
					floated="left"
					size="tiny"
					src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${tube.picto ? tube.picto.filename : process.env.REACT_APP_TUBE_PIC_FILENAME}`}
					style={{ marginRight: 0, padding: "0 0px" }}
				/>
				<Card.Header style={{ width: "100%", textAlign: "center", minHeight: "55px", margin: "auto 0" }}>{tube.label}</Card.Header>
			</Card.Content>

			<Card.Content style={{ minHeight: "150px" }}>
				{tube && tube.canceled && (
					<Label as="a" onClick={() => setTubeNotPresent(tube, true)}>
						Echantillon non apporté
						<Icon style={{ paddingLeft: "5px" }} name="delete" />
					</Label>
				)}
				{tube && !tube.canceled && (
					<>
						<ButtonBarcodeTube
							key={"barcode" + tube.properties_id}
							barcode={tube.barcode}
							submitBarCode={submitBarCode}
							regex={regexForTube(tube)}
							isSelected={isSelected}
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								openBarcode(tube);
							}}
							disabled={disabled}
							cancelSelect={cancelSelect}
							select={selectTube}
						/>
						{!tube.barcode && (
							<SecondaryRedButton
								text="Echantillon non apporté"
								style={{
									marginTop: 10,
									marginBottom: 10,
									width: "100%",
									textTransform: "uppercase",
									fontSize: "0.8em",
								}}
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									setTubeNotPresent(tube, false);
								}}
								disabled={disabled}
							/>
						)}
					</>
				)}
			</Card.Content>
		</Card>
	);
};

export default TubeDepositCard;
